/* eslint-disable no-negated-condition */
import isEmpty from 'lodash/isEmpty'
import StrapiCategoryPage from './StrapiCategoryPage'
import INListing from '@/components/Stocks/Pages/StockListingPage'
import { GreenButton } from '@/components/NewHomepage/Button'

const StocksCategory = props => {
  if (!isEmpty(props.strapiApiData)) {
    return <StrapiCategoryPage {...props} />
  } else
    return (
      <div>
        <INListing {...props} />
        {!props.headers.Authorization && (
          <div className="sticky bottom-0 z-20 block lg:hidden">
            <GreenButton
              btnText="Create FREE Demat Account"
              withLogin
              eventAction="IN_STOCKS_L1"
              addclassName="!rounded-none"
            />
          </div>
        )}
      </div>
    )
}

export default StocksCategory
